import { render } from "./VitrineProductModal.vue?vue&type=template&id=66a15ce8"
import script from "./VitrineProductModal.vue?vue&type=script&lang=js"
export * from "./VitrineProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__